import { css } from '@emotion/react';
import { faMap } from '@fortawesome/pro-solid-svg-icons';
import { EmptyStateComponent } from '~/_shared/components/emptyState/emptyState.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';

const wrapperStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 36,
  justifyContent: 'center',
});

const hintStyle = (theme: Theme) => css({
  color: theme.textColors.secondary,
  fontSize: 12,
  padding: '8px 24px',
  textAlign: 'center',
  whiteSpace: 'pre-line',
});

export const MobileEmptyMapListingComponent = () => {
  const [t] = useTranslation();

  return (
    <div css={wrapperStyle}>
      <EmptyStateComponent
        description={t('mapListing.emptyState.description')}
        icon={faMap}
        title={t('mapListing.emptyState.title')}
      />
      <div css={hintStyle} >
        {t('mapListing.emptyState.mobileHint')}
      </div>
    </div>
  );
};
